import { Cell, Pie, PieChart, ResponsiveContainer, Sector } from "recharts";

import HNSColors from "../../../../ui library/HNSColors";

import FeeSchedulePieTooltip from "./FeeSchedulePieTooltip";

function renderActiveSlice({
  cx,
  cy,
  innerRadius,
  outerRadius,
  startAngle,
  endAngle,
  fill,
}) {
  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={(outerRadius || 0) + 10}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        stroke={HNSColors.neutrals[900]}
        strokeWidth={2}
        style={{
          filter: "drop-shadow(0px 3px 5px rgba(15, 23, 42, 0.25))",
          cursor: "pointer",
        }}
      />
    </g>
  );
}

export default function FeeScheduleChart({
  chartData,
  activeIndex,
  activeSlice,
  activeTooltipPosition,
  onHoverSlice,
  onLeaveSlice,
}) {
  return (
    <div className="relative h-[180px] min-h-[180px] overflow-visible">
      {activeSlice && activeTooltipPosition ? (
        <div
          className="pointer-events-none absolute z-20"
          style={{
            left: activeTooltipPosition.x,
            top: activeTooltipPosition.y,
            transform: "translate(-50%, -50%)",
          }}
        >
          <FeeSchedulePieTooltip item={activeSlice} />
        </div>
      ) : null}
      <ResponsiveContainer width="100%" height="100%">
        <PieChart style={{ overflow: "visible" }}>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={72}
            paddingAngle={2}
            stroke="none"
            activeIndex={activeIndex}
            activeShape={renderActiveSlice}
            onMouseEnter={(_, index) => {
              const nextSlice = chartData[index];
              if (nextSlice?.name && nextSlice.name !== "No Data") {
                onHoverSlice(nextSlice.name);
              }
            }}
            onMouseLeave={onLeaveSlice}
          >
            {chartData.map((entry) => (
              <Cell
                key={entry.name}
                fill={entry.color}
                style={{ cursor: entry.name === "No Data" ? "default" : "pointer" }}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
